import { Serializable } from '../interfaces/serializable';
import { Address } from './address.model';
import { Partner } from './partner.model';

export class Agency implements Serializable {

    private _uuid: string = null;
    public name: string = "";
    public phone: string = null;
    public email: string = null;
    public website: string = null;
    public address: Address = null;
    public partner: Partner = null;
    public hasFaceToFaceAvailabilities: boolean = false;
    public hasPhoneAvailabilities: boolean = false;
    public createdAt: Date = null;
    public updatedAt: Date = null;

    public getId(): string {
        return this._uuid;
    }

    public getIRI(): string {
        return '/api/agencies/' + this.getId();
    }

    public getGoogleMapPlaceUrl(): string {
        return 'https://www.google.com/maps/search/?api=1&query=' + encodeURI(this.address.getFullName());
    }

    public update(data: any = {}): this {
        if (!data) {
            return null;
        }

        const properties = Object.getOwnPropertyNames(this);
        Object.keys(data).forEach((key) => {
            switch (key) {
                case '_uuid': break;                
                default:
                    if (properties.includes(key)) {
                        this[key] = data[key];
                    }
                    break;
            }
        });

        return this;
    }

    public deserialize(input: any = {}): this {
        if (!input) {
            return null;
        }

        const properties = Object.getOwnPropertyNames(this);
        Object.keys(input).forEach((key) => {
            if (input[key] !== null) {
                switch (key) {
                    case 'uuid':
                        this._uuid = input[key];
                        break;
                    case 'address':
                        this[key] = new Address().deserialize(input[key]);
                        break;
                    case 'partner':
                        this[key] = new Partner().deserialize(input[key]);
                        break;
                    case 'createdAt':
                    case 'updatedAt':
                        this[key] = new Date(input[key]);
                        break;                    
                    default:
                        if (properties.includes(key)) {
                            this[key] = input[key];
                        }
                        break;
                }
            }
        });

        return this;
    }

    public serialize(): any {
        var output = {};

        Object.getOwnPropertyNames(this).forEach(property => {
            switch (property) {
                case '_uuid':
                    if (this[property]) {
                        output['uuid'] = this[property];
                    }
                    break;                
                default:
                    output[property] = this[property];
                    break;
            }
        });

        return output;
    }
}
